import { render, staticRenderFns } from "./TeamRequestsPage.vue?vue&type=template&id=55e163e1"
import script from "./TeamRequestsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRequestsPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e163e1')) {
      api.createRecord('55e163e1', component.options)
    } else {
      api.reload('55e163e1', component.options)
    }
    module.hot.accept("./TeamRequestsPage.vue?vue&type=template&id=55e163e1", function () {
      api.rerender('55e163e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/client/team-requests/TeamRequestsPage.vue"
export default component.exports